import React from "react";
import { useLocation } from "react-router-dom";
import "./applications.css";
import Devis from "../../components/devis";

const featureTiles = [
  {
    title: "Fiche patient digital",
    text:
      "Toutes les informations sont réunies dans une fiche unique pour accélérer les consultations et maintenir chaque dossier à jour.",
    image: "assets/images/services/Frame596.png",
    link: "https://visibilitycam.com/fiches",
    type: "web",
  },
  {
    title: "Saisie des actes",
    text:
      "Choisissez un acte, sélectionnez les dents concernées, et validez en quelques clics pour garder votre planning clair.",
    image: "assets/images/services/app-mobilie-web.png",
    link: "https://visibilitycam.com/actes",
    type: "mobile",
  },
  {
    title: "Paiements sécurisés",
    text:
      "Suivez les règlements à débit immédiat, gérez les acomptes et exportez les relevés pour la comptabilité.",
    image: "assets/images/services/services1.png",
    link: "https://visibilitycam.com/paiements",
    type: "web",
  },
  {
    title: "Feuilles de soins",
    text:
      "Rédigez et remplissez automatiquement les feuilles de soins CNOPS/CNSS avec validation intégrée.",
    image: "assets/images/services/services2.png",
    link: "https://visibilitycam.com/soins",
    type: "web",
  },
  {
    title: "Agenda collaboratif",
    text:
      "Réservez, partagez les créneaux et profitez d’alertes automatiques pour chaque membre de l’équipe.",
    image: "assets/images/services/services3.png",
    link: "https://visibilitycam.com/agenda",
    type: "mobile",
  },
  {
    title: "Support dédié",
    text:
      "Un service après-vente disponible 7j/7, prêt à répondre par chat, téléphone ou visioconférence.",
    image: "assets/images/services/services4.png",
    link: "https://visibilitycam.com/support",
    type: "web",
  },
];

const Applications = () => {
  const location = useLocation();

  // Détection du type de page (web ou mobile)
  const pageType = location.pathname.includes("mobile")
    ? "mobile"
    : "web";

  // Filtrage des fonctionnalités selon le type
  const filteredFeatures = featureTiles.filter(
    (tile) => tile.type === pageType
  );

  return (
    <div>
      <div className="applications-page">
        <div className="header-service">
          <div className="row">
            <div className="col-2">
              <img
                src="assets/images/vecto_image_left_yellow-removebg-preview.PNG"
                className="vecto_image_left_yellow"
                alt=""
              />
            </div>

            <div className="col-10">
              <div className="row">
                <div className="col-md-5">
                  <img
                    src={
                      pageType === "mobile"
                        ? "assets/images/services/app-mobile.png"
                        : "assets/images/services/app-web.png"
                    }
                    className="Frame595"
                    alt=""
                  />
                  <h5 className="green Frame596">
                    {pageType === "mobile"
                      ? "Application Mobile"
                      : "Application Web"}
                  </h5>
                  <p className="text-jsutify">
                    {pageType === "mobile"
                      ? "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat."
                      : "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat."}
                  </p>
                </div>

                <div className="col-md-5">
                  <img
                    src="assets/images/services/app-mobilie-web.png"
                    className="images1"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="ease-section">
          <div className="container">
            <p className="eyebrow">Fonctionnalités</p>
            <div className="section-heading">
              <h2>Facile à utiliser</h2>
              <p>
                Pensées pour les équipes médicales, nos applications offrent
                une expérience fluide entre chaque écran et une interface
                lisible pour être opérationnel en quelques minutes.
              </p>
            </div>
          </div>

          <div className="cards-grid container">
            <div className="row">
              {filteredFeatures.map((tile) => (
                <div key={tile.title} className="col-md-4 mb-4">
                  <a
                    className="feature-card feature-card-link"
                    href={tile.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {tile.image && (
                      <img
                        src={tile.image}
                        alt={tile.title}
                        className="feature-card-image"
                      />
                    )}
                    <div className="feature-card-content">
                      <h3>{tile.title}</h3>
                      <p>{tile.text}</p>
                      <span className="btn primary">Voir plus</span>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Devis />
    </div>
  );
};

export default Applications;
